import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import LazyLoad from 'react-lazyload'

const AssignmentEditor = ({ url }) => {
	return (
		<Fragment>
			<Helmet>
				<script src="https://projects.sfchronicle.com/shared/js/responsive-frame.js"></script>
			</Helmet>
			<LazyLoad>
			  <iframe
			    title="Survey: Questions about COVID"
			    src={url}
			    id="assignment-editor"
			    is="responsive-iframe"
			    interval="1"
			  ></iframe>
			</LazyLoad>
		</Fragment>
	)
}

export default AssignmentEditor